// UTM parameter capture — persists across the session so a lead submitted 10 minutes after
// landing still carries the campaign attribution.

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
const STORAGE_KEY = 'mk_utm';
const TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

export function captureUtmFromUrl() {
  if (typeof window === 'undefined') return;
  try {
    const params = new URLSearchParams(window.location.search);
    const captured = {};
    let found = false;
    UTM_KEYS.forEach(k => {
      const v = params.get(k);
      if (v) {
        captured[k] = v.slice(0, 120);
        found = true;
      }
    });
    if (found) {
      captured._at = Date.now();
      localStorage.setItem(STORAGE_KEY, JSON.stringify(captured));
    }
  } catch (e) { /* ignore */ }
}

export function getStoredUtm() {
  if (typeof window === 'undefined') return {};
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (parsed._at && Date.now() - parsed._at > TTL_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return {};
    }
    const out = {};
    UTM_KEYS.forEach(k => { if (parsed[k]) out[k] = parsed[k]; });
    return out;
  } catch (e) { return {}; }
}
